import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "手写文字生成 - 在线生成手写图片与 PDF",
      description:
        "手写文字生成网站，支持多种字体和背景，在线生成高质量手写文字图片与 PDF。适合作业、论文、信件等场景，支持自定义字体、背景与参数调节。",
    },
  },
  {
    path: "/About",
    name: "About",
    component: () => import("../views/AboutView.vue"),
    meta: {
      title: "关于 - 手写文字生成",
      description: "关于本网站与功能介绍、使用方法及隐私说明。",
    },
  },
  {
    path: "/Introduce",
    name: "Introduce",
    component: () => import("../components/Introduce.vue"),
    meta: {
      title: "功能介绍 - 手写文字生成",
      description: "了解网站核心功能、参数配置与使用技巧。",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
